import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProcessSection } from './components/ProcessSection';
import { CourseSection } from './components/CourseSection';
import { TrustSection } from './components/TrustSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { LocationSection } from './components/LocationSection';
import { BookingToast } from './components/BookingToast';
export function App() {
  return <div className="w-full min-h-screen bg-[var(--warm-cream)] font-sans text-[var(--text-dark)] overflow-x-hidden" data-id="element-0">
      <BookingToast data-id="element-1" />
      <HeroSection data-id="element-2" />
      <AboutSection data-id="element-3" />
      <ServicesSection data-id="element-4" />
      <GallerySection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <ProcessSection data-id="element-7" />
      <CourseSection data-id="element-8" />
      <TrustSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <LocationSection data-id="element-11" />

      {/* Simple Footer */}
      <footer className="w-full py-8 bg-[#2C1810] text-center border-t border-white/10" data-id="element-12">
        <p className="text-white/50 text-sm font-light" data-id="element-13">
          © {new Date().getFullYear()} Iara Oliver Estética. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}